import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex } from 'reflexbox'
import Select from 'react-select'
import Chip from 'react-toolbox/lib/chip'
import { IconButton } from 'react-toolbox/lib/button'
import Body2 from 'components/typography/body2/index'
import Body from 'components/typography/body1/index'

import {
  querySelector,
} from './selectors'
import {
  toggleDashboardQuery
} from './actions'
import {
  ProductHierarchyEnum,
  PartnerSiteEnum
} from './constants'
import styles from './styles.scss'


const mapStateToProps = (state) => {
  return {
    querySelection: querySelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleCollapse: () => dispatch(toggleDashboardQuery())
  }
}

class DashboardOptions extends Component {
  renderChips() {
    const { querySelection } = this.props
    const combinedFilters = { ...ProductHierarchyEnum, ...PartnerSiteEnum }
    const results = Object.values(combinedFilters).reduce((result, value) => {
      const filterValues = querySelection(value)
      return [...result, ...filterValues]
    }, [])

    return results.map((result, index) => {
      return (
        <Chip styleName='queryChip' key={index}>
          <Body>
            {result.label}
          </Body>
        </Chip>
      )
    })
  }

  render() {
    const options = [
      {
        value: 'my dashboard',
        label: 'my dashboard'
      }
    ]

    return (
      <Flex wrap styleName='dashboardOptions' mx={2} >
        <Flex wrap styleName='filterOptions'>
          <IconButton icon={'filter_list'} onClick={this.props.toggleCollapse} />
          <Body2>Filters</Body2>
          {this.renderChips()}
        </Flex>
        {/* <Flex styleName='reportSelection'>
          <Body2>Saved Reports</Body2>
          <Select
            styleName='reportSelector'
            name="reports"
            options={options}
          />
        </Flex> */}
      </Flex>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(DashboardOptions)
